import { deleteApi, get, post } from "../GenericServices";

const ParkAuto = {
  getParkAutos: (queryString) => {
    return get(`park-auto${queryString !== "" ? `?${queryString}` : ""}`);
  },
  getParkAuto: (id) => {
    return get(`park-auto/${id}`);
  },
  setParkAuto: (data) => {
    return post(`park-auto`, data);
  },
  deleteParkAuto: (id) => {
    return deleteApi(`park-auto/${id}`);
  },
  exportParkAuto: () => {
    return get(`park-auto/export`);
  },
};

export default ParkAuto;
